import React, { useEffect, useState } from 'react';
import { FaDownload } from 'react-icons/fa';

const InstallPWA: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e: any) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            // Update UI notify the user they can install the PWA
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) {
            return;
        }
        // Show the install prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        // We've used the prompt, and can't use it again, discard it
        setDeferredPrompt(null);
        setIsInstallable(false);
    };

    if (!isInstallable) {
        return null;
    }

    return (
        <button
            onClick={handleInstallClick}
            className="btn d-flex align-items-center gap-2 mt-auto mx-3 mb-3 text-white"
            style={{
                background: 'linear-gradient(45deg, #3b82f6, #2563eb)',
                border: 'none',
                borderRadius: '12px',
                padding: '12px 16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                transition: 'all 0.2s ease',
                width: 'calc(100% - 32px)'
            }}
        >
            <div className="d-flex align-items-center justify-content-center bg-white bg-opacity-25 rounded-circle" style={{ width: '32px', height: '32px' }}>
                <FaDownload size={14} />
            </div>
            <div className="d-flex flex-column align-items-start" style={{ lineHeight: '1.2' }}>
                <span className="fw-bold" style={{ fontSize: '0.9rem' }}>Install App</span>
                <span className="opacity-75" style={{ fontSize: '0.75rem' }}>Get the Native App</span>
            </div>
        </button>
    );
};

export default InstallPWA;
